var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['full-width col', { 'bg-grey-1': !_vm.isMobile }]},[(_vm.loading)?_c('SAIPageSpinner'):_vm._e(),(!_vm.loading)?_vm._t("header"):_vm._e(),(!_vm.loading)?_c('div',{class:[
      'relative-position',
      { 'row desktop-single-column q-px-md': !_vm.isMobile }
    ]},[(!_vm.isMobile)?_c('div',{staticClass:"q-mr-md q-pr-sm"},[_vm._t("card")],2):_vm._e(),_c('div',{class:[
        'q-px-md q-pb-lg',
        { 'q-mb-lg bg-white rounded-borders-lg col': !_vm.isMobile }
      ]},[(_vm.isMobile)?_vm._t("card"):_vm._e(),_vm._t("details")],2)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }